import {Box, Button, Grid, Typography, styled} from "@mui/material";
import React from "react";
import SubTitle from "../../../components/SubTitle";
import {useRecoilValue} from "recoil";
import {tokenSelector} from "../../../Recoil/Atom/authState";
import {useNavigate, useParams} from "react-router-dom";
import MWCaption from "../../../components/MWCaption";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import {ReactComponent as WordIcon} from "../../../assets/images/word.svg";

const ExamQRCodeContainer = styled(Grid)(({theme}) => ({
  marginTop: "32px",
  alignItems: "center",
  paddingBottom: "32px",
  backgroundColor: "#fff",
}));

const TypographyList = styled(Typography)({
  lineHeight: 2,
  fontWeight: 500,
});

const ExamQRCode = () => {
  const {id} = useParams();
  const navigate = useNavigate();
  const tokenState = useRecoilValue(tokenSelector);
  return (
    <React.Fragment>
      <SubTitle subTitle="QR 코드" />
      <ExamQRCodeContainer container rowSpacing={4}>
        <MWCaption title="QR CODE" color="#880E4F" icon={<QrCodeScannerIcon />}>
          <Button
            variant="contained"
            color="primary"
            size="small"
            sx={{marginLeft: "18px"}}
            startIcon={<WordIcon width="18px" height="18px" />}
          >
            <a
              href={`/API/ExportCurriculumQRCodeToWord?token=${tokenState}&id=${id}`}
              style={{color: "white"}}
            >
              word로 저장
            </a>
          </Button>
        </MWCaption>
        <Grid item xs={12} sm={12} md={5} display="flex" justifyContent="center">
          <img
            src={`/API/CurriculumQRCodeImage?token=${tokenState}&id=${id}`}
            alt=""
            style={{display: "block", width: "300px"}}
          />
        </Grid>
        <Grid item sm={0} md={0.5} sx={{width: "100%", height: "100%"}}>
          <Box
            sx={{
              display: {xs: "none", sm: "none", md: "block"},
              width: "10px",
              height: "260px",
              backgroundColor: "#880E4F",
            }}
          ></Box>
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <Typography variant="h4" mb={3} fontWeight={600}>
            QR 코드 사용법
          </Typography>
          <TypographyList>1. 휴대폰 기본카메라(또는 포털 검색) 어플을 실행합니다.</TypographyList>
          <TypographyList>2. QR코드 이미지를 포커싱합니다.</TypographyList>
          <TypographyList>3. 개인별 아이디 및 패스워드를 입력 후 평가에 참여합니다.</TypographyList>
        </Grid>
      </ExamQRCodeContainer>
      <Box display="flex" justifyContent="center" alignItems="center" padding="24px">
        <Button
          variant="contained"
          color="warning"
          onClick={() => navigate(-1)}
          sx={{color: "white", fontWeight: "700"}}
        >
          뒤로가기
        </Button>
      </Box>
    </React.Fragment>
  );
};

export default ExamQRCode;
